var comp = 'action-item';
export var dataHooks = {
  tooltip: "".concat(comp, "-tooltip")
};